import type { Idea, WatchlistPlan } from '@thinkalpha/platform-ws-client/contracts/ideas/index.js';

export type SetWatchlistIdeaAction = {
    type: 'setWatchlistIdea';
    tabId: string;
    idea: Idea & { plan: WatchlistPlan };
    isIdeaDirty?: boolean;
};

export const setWatchlistIdea = (
    tabId: string,
    idea: Idea & { plan: WatchlistPlan },
    isIdeaDirty?: boolean,
): SetWatchlistIdeaAction => ({
    tabId,
    idea,
    isIdeaDirty,
    type: 'setWatchlistIdea',
});

export type WatchlistActions = SetWatchlistIdeaAction;
